import './App.css';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Page404 from './pages/404';
import Calendar from './pages/Calendar';
import ViewEvent from './pages/ViewEvent';
import Events from './pages/Events';


function App() {

  return (
    <BrowserRouter basename='/'>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path="/NotFound" element={<Page404 />} />
          <Route path="/Calendar" element={<Calendar />} />
          <Route path="/ViewEvent/:id" element={<ViewEvent />} />
          <Route path="/Events" element={<Events />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter >
  );
}

export default App;
